import { Node } from "konva/lib/Node";
import { Color } from "types/global";


/** restituisce un colore piu' scuro (o chiaro) in base al percent (da 0 a 1) */
export function brighten(color:string, percent:number):Color {
	if ( color==null || percent < 0 ) return "#000000"
	color = color.padEnd(7, "0")
	const calc = (sub1:number, sub2:number) => 
		Math.min(
			255, 
			Math.floor(parseInt(color.slice(sub1, sub2), 16) * percent)
		).toString(16).padStart(2, "0")
	return `#${calc(1, 3)}${calc(3, 5)}${calc(5, 7)}`
}


/** restituisce la posizione del mouse relativamente al nodo passato come parametro */
export function getRelativePointerPosition(node:Node) {
	const transform = node.getAbsoluteTransform().copy();
	// to detect relative position we need to invert transform
	transform.invert();
	// get pointer (say mouse or touch) position
	const pos = node.getStage().getPointerPosition();
	// now we can find relative point
	return transform.point(pos);
}
